export const CATEGORIES = [
  "Steel & Metals",
  "Machine Tools",
  "Automation & Robotics",
  "Electrical & Electronics",
  "Polymers & Plastics",
  "Rubber Components",
  "Packaging & Printing",
  "Hydraulics & Pneumatics",
  "Bearings & Power Transmission",
  "Motors & Pumps",
  "Sensors & Controls",
  "Tools & Hardware",
  "Chemicals & Raw Materials",
  "Industrial Services",
  "Logistics & Warehousing",
  "Testing & Quality Control",
  "Safety Equipment",
  "Fabrication & Welding",
  "General Industrial"
];

export const INDUSTRIAL_LOCATIONS = [
  "Bengaluru - Peenya Industrial Area",
  "Bengaluru - Electronic City",
  "Bengaluru - Bommasandra Industrial Area",
  "Bengaluru - Jigani Industrial Area",
  "Bengaluru - Whitefield",
  "Pune - Chakan Industrial Area",
  "Pune - Bhosari MIDC",
  "Pune - Ranjangaon MIDC",
  "Mumbai - MIDC Andheri",
  "Mumbai - Bhiwandi Industrial Zone",
  "Mumbai - Tarapur MIDC",
  "Chennai - Sriperumbudur Industrial Hub",
  "Chennai - Ambattur Industrial Estate",
  "Ahmedabad - Naroda GIDC",
  "Ahmedabad - Vatva GIDC",
  "Ahmedabad - Sanand GIDC",
  "Delhi NCR - Gurgaon Udyog Vihar",
  "Delhi NCR - Noida Sector 63",
  "Delhi NCR - Okhla Industrial Area",
  "Delhi NCR - Faridabad Sector 25",
  "Coimbatore - SIDCO Industrial Estate",
  "Hyderabad - Cherlapally Industrial Park",
  "Surat - Hazira GIDC",
  "Vadodara - Makarpura GIDC"
];
